import {Injectable, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from '@ems/shared';
@Injectable()
export class LocalStorageService {
  constructor(private http: HttpClient, private authService: AuthService, private sharedService: SharedService, private cookieService: CookieService) {
  }

  getToken() {
    return localStorage.getItem('token');
  }

  setToken(token) {
    localStorage.setItem('token', token);
  }

  isTokenPresent() {
    if (!localStorage.getItem('token')) {
      localStorage.clear();
    }
  }

  setProfile(clientProfile) {
    localStorage.setItem('client', clientProfile);
    const clientProfileParse = JSON.parse(clientProfile);
    if (clientProfileParse.clientName === 'All') {
      clientProfileParse.clientId = 0;
      clientProfileParse.businessUnit = 'All';
    }
    localStorage.setItem('UUID', `${this.sharedService.getUserId()}|${this.authService.getUsertype()}`);
    localStorage.setItem('db_clientSelected', `${clientProfileParse.clientId}|${clientProfileParse.businessUnit}`);
    const uuidValue = `"${this.sharedService.getUserId()}|${this.authService.getUsertype()}"`;
    const dbClientValue = `"${clientProfileParse.clientId}|${clientProfileParse.businessUnit}"`;
    document.cookie = 'UUID=' + uuidValue + '; path=/; Secure; SameSite=Strict';
    document.cookie = 'db_clientSelected=' + dbClientValue + '; path=/; Secure; SameSite=Strict';
    document.cookie = 'Adobe UUID="' + this.sharedService.getHashedUserId() + '"; path=/; Secure; SameSite=Strict';
    document.cookie = 'Adobe User Type="' + this.authService.getUsertype() + '"; path=/; Secure; SameSite=Strict';
  }

  getProfile() {
    return localStorage.getItem('client');
  }

  setExpiryDateTime(time) {
    localStorage.setItem('tknExpireTime', time);
  }

  getExpiryDateTime() {
    return localStorage.getItem('tknExpireTime');
  }

  clearLocalStorage() {
    localStorage.clear();
    this.cookieService.deleteAll();
  }

}
